var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.014 15.9912C17.8825 15.9912 17.7522 15.9652 17.6307 15.9147C17.5092 15.8643 17.3989 15.7904 17.306 15.6972L12.021 10.3972L6.72101 15.6822C6.62863 15.7776 6.51818 15.8536 6.3961 15.9058C6.27402 15.9581 6.14277 15.9854 6.00999 15.9864C5.87722 15.9874 5.74558 15.9619 5.62276 15.9114C5.49994 15.861 5.3884 15.7866 5.29464 15.6925C5.20088 15.5985 5.12679 15.4868 5.07668 15.3638C5.02658 15.2408 5.00146 15.1091 5.0028 14.9764C5.00414 14.8436 5.0319 14.7124 5.08448 14.5905C5.13705 14.4686 5.21338 14.3583 5.30901 14.2662L11.317 8.27521C11.5045 8.08774 11.7588 7.98242 12.024 7.98242C12.2892 7.98242 12.5435 8.08774 12.731 8.27521L18.723 14.2842C18.8625 14.4242 18.9575 14.6023 18.9958 14.7962C19.0341 14.9901 19.0142 15.191 18.9384 15.3735C18.8627 15.5561 18.7345 15.712 18.5702 15.8218C18.4058 15.9316 18.2126 15.9902 18.015 15.9902L18.014 15.9912Z",
    fill: "#393A3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUp);
export default __webpack_public_path__ + "static/media/chevron-up.fef3de1e8270bb00f8707ba9a447d65d.svg";
export { ForwardRef as ReactComponent };